import { render, staticRenderFns } from "./CampaignSalesOrder.vue?vue&type=template&id=236fdb20&scoped=true"
import script from "./CampaignSalesOrder.vue?vue&type=script&lang=js"
export * from "./CampaignSalesOrder.vue?vue&type=script&lang=js"
import style0 from "./CampaignSalesOrder.vue?vue&type=style&index=0&id=236fdb20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236fdb20",
  null
  
)

export default component.exports